import "./hb-link.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

const hb = new URL("../../../public/hb.svg", import.meta.url).href;

export default (user) => html`
    <div
        id="hb-link"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <button
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        ♒️ Aquarius™ Browser
                        <!--ℹ️-->
                    </button>
                    <aside>
                        <button>
                            <svg
                                onclick="alert('B-Sticker and B-History coming soon!')"
                                class="w-5 h-5 fill-blue-500 mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512">
                                <path
                                    d="M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64zM32 176l448 0 0 240c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-240zm152 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z" />
                            </svg>
                        </button>
                        <button
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-link">
                            <svg
                                class="w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 384 512">
                                <path
                                    d="M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z" />
                            </svg>
                            <span class="sr-only">Close</span>
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <form
                    id="hb-link-form"
                    class="p-4 md:p-5 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    <div class="grid gap-2">
                        <div class="mt-0">
                            <label
                                for="hb-link-url"
                                class="inline-flex justify-between align-middle w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span class="text-base">
                                    💙 HeartBank® Link
                                </span>
                                <aside>
                                    <button
                                        type="button"
                                        id="hb-link-button"
                                        class="mr-4">
                                        📋
                                    </button>
                                    <button
                                        type="button"
                                        id="hb-link-clear"
                                        class="mr-0">
                                        🗑️
                                    </button>
                                </aside>
                            </label>
                            <div class="relative w-full mb-4">
                                <div
                                    id="hb-link-clear2"
                                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M384 192c53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 5.4 .5 10.8 1.3 16L159.6 184.1c-16.9-15-39.2-24.1-63.6-24.1-53 0-96 43-96 96s43 96 96 96c24.4 0 46.6-9.1 63.6-24.1L289.3 400c-.9 5.2-1.3 10.5-1.3 16 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-24.4 0-46.6 9.1-63.6 24.1L190.7 272c.9-5.2 1.3-10.5 1.3-16s-.5-10.8-1.3-16l129.7-72.1c16.9 15 39.2 24.1 63.6 24.1z" />
                                    </svg>
                                </div>
                                <input
                                    autocomplete="on"
                                    type="text"
                                    id="hb-link-url"
                                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Enter URL" />
                                <button
                                    type="button"
                                    id="hb-link-submit"
                                    type="button"
                                    class="hidden absolute inset-y-0 end-0 items-center pe-3">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" />
                                    </svg>
                                </button>
                            </div>
                            <div class="relative w-full">
                                <img
                                    id="hb-link-image"
                                    class="w-full h-auto hidden"
                                    src="${hb}" />
                            </div>
                        </div>
                        <div>
                            <label
                                for="hb-link-description"
                                class="w-full inline-flex justify-between align-middle mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span class="text-base"> 💙 Description </span>
                                <div>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-link-magic">
                                        🪄
                                    </button>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-link-paste">
                                        📋
                                    </button>
                                    <button type="button" id="hb-link-trash">
                                        🗑️
                                    </button>
                                </div>
                            </label>
                            <section class="relative">
                                <textarea
                                    id="hb-link-description"
                                    rows="4"
                                    class="block outline-0 p-2.5 w-full h-40 text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Optional: Include a description here to go along with your B-Link"></textarea>
                                <button
                                    class="hidden absolute bottom-0 left-2"
                                    type="button"
                                    id="hb-link-record">
                                    🎙️
                                </button>
                            </section>
                        </div>
                    </div>
                    <!-- Modal footer: Mint Link -->
                    <div
                        class="p-2 border-0 border-gray-200 rounded-b dark:border-gray-600">
                        <section
                            id="hb-post-external"
                            class="w-full flex items-center justify-between">
                            <button
                                id="hb-link-share"
                                type="button"
                                class="mr-1 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                Share B-Link
                            </button>
                            <button
                                id="hb-link-copy"
                                type="button"
                                class="ml-1 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                Copy B-Link
                            </button>
                        </section>
                        <div
                            class="${user
                                ? ""
                                : "hidden"} pt-3 flex flex-col gap-3">
                            <button
                                type="submit"
                                class="pt-3 text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-blue-400 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-blue-700 dark:hover:bg-blue-800 dark:focus:ring-blue-900">
                                Broadcast B-Link
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
`;
